import {
  type FlowPatientDataStoreBlockConfig,
  FlowPatientDataStoreConfigSchema,
  FlowPatientDataStoreEndpoint,
  FlowProducedType,
} from 'flow-schema';

import { PatientDataStoreFormFields } from './FormFields';
import { PatientDataStoreDocumentationMarkdown } from './documentation';
import { ProducedType } from '../../../types';
import { type BlockConfigProps } from '../../types';

export const PatientDataStoreConfig: BlockConfigProps<FlowPatientDataStoreBlockConfig> = {
  nodeHandles: [{ type: 'target' }, { type: 'source' }],
  defaultLabelPrefix: 'SmartFetchFromChart',
  defaultConfig: {
    endpoint: FlowPatientDataStoreEndpoint.DocumentMetadata,
    patient: {
      sourceBlockName: '',
      consumesType: FlowProducedType.Patient,
    },
    returnType: ProducedType.PdsDocumentMetadata,
  },
  configFields: {
    schema: FlowPatientDataStoreConfigSchema,
    FormFields: PatientDataStoreFormFields,
  },
  documentationMarkdown: PatientDataStoreDocumentationMarkdown,
};
